import { match } from 'ts-pattern';
import { getIdSequence } from '@salsita-ai/platform-project-sdk/domain';
import { LegsBrago, LegsCono, LegsEbonu3DoubleEik, LegsEbonu3Eik, LegsEbonuEik, LegsElmo, LegsElmoDouble, LegsLivio, LegsLivioSchuinEik, LegsNovaroEik, LegsNovaroStaal, LegsOslo, LegsPapillon, LegsPapillonStrak, LegsRobuDoubleEik, LegsRobuEik, LegsTwist3, LegsTwist4, Top } from '../__generated/model/versions/v3.js';
import { ColorOak, LegsNovaroDoubleEik, LegsNovaroDoubleStaal, LegsThickness } from '../__generated/model/versions/v4.js';
export const migrateToV4 = (state)=>{
    const idSequence = getIdSequence([], []);
    const curentTopColor = state.find(Top.is)?.color;
    const newOakLegsColor = ColorOak.is(curentTopColor) ? curentTopColor : ColorOak.UltraMatteLak;
    return state.map((entity)=>{
        return match(entity).returnType()/**
         * The new single Novaro has the plain name for consistency, the double is a new entity type.
         */ .with({
            type: LegsNovaroEik.type
        }, (entity)=>({
                ...entity,
                id: idSequence.nextId(LegsNovaroDoubleEik.type),
                type: LegsNovaroDoubleEik.type,
                color: newOakLegsColor
            })).with({
            type: LegsNovaroStaal.type
        }, (entity)=>({
                ...entity,
                id: idSequence.nextId(LegsNovaroDoubleStaal.type),
                type: LegsNovaroDoubleStaal.type
            }))/**
         * The two Twist legs now have thickness options.
         */ .with({
            type: LegsTwist3.type
        }, (entity)=>({
                ...entity,
                legThickness: LegsThickness.Thick
            })).with({
            type: LegsTwist4.type
        }, (entity)=>({
                ...entity,
                legThickness: LegsThickness.Thick
            }))/**
         * All oak leg styles now have a color.
         */ .with({
            type: LegsBrago.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsCono.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsEbonuEik.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsEbonu3Eik.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsEbonu3DoubleEik.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsElmo.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsElmoDouble.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsLivio.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsLivioSchuinEik.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsOslo.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsPapillon.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsPapillonStrak.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsRobuEik.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).with({
            type: LegsRobuDoubleEik.type
        }, (entity)=>({
                ...entity,
                color: newOakLegsColor
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v4.js.map